module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['table-caption', {
      isSort: _vm.column.sort,
      active: _vm.active
    }],
    style: (_vm.columnStyle),
    on: {
      "click": _vm.handleClick
    }
  }, [_vm._v("\n  " + _vm._s(_vm.column.label) + "\n  "), (_vm.column.sort) ? _c('span', {
    staticClass: "arrow",
    class: _vm.classDirection
  }) : _vm._e(), _vm._v(" "), (_vm.column.checkBox) ? _c('VCheckBox', {
    ref: "checkBox",
    attrs: {
      "isCheckAll": true,
      "checkGroupValue": _vm.checkGroupValue,
      "indeterminate": _vm.indeterminate
    },
    on: {
      "checkValue": _vm.handleCheckAll
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06133688","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VTable/VTh.vue
// module id = 1682
// module chunks = 1